module.exports = __webpack_public_path__ + "static/media/BNF-final.9b0de3d0.svg";